import axios from "axios";

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;

export function getSmartVitalData() {
  return axios.get(
    `${CMS_BASE_URL}smartvital-news?populate=first,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub`, 
  );
}